var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"trigger-standard-view",on:{"click":function($event){return _vm.$bus.$emit('setBestSellerPanel', false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }